import styled from "styled-components";
import { BASIC_DARK_GRAY, BASIC_LINE } from "../../../constants/colors";
import { PageRoutes } from "../../../constants/routes";
import { useAuth } from "../../../hooks/useAuth";
import { Link } from "../../atoms/Link";
import { BackToTopPageButton } from "../../molecules/BackToTopPageButton";
import { FavoriteStoreList } from "../../organisms/store/FavoriteStoreList";
import { useMyPage } from "./hook";

const userIcon = require("../../../assets/user_icon.png");

export const MyPage: React.FC = () => {
  const { loggedInUser } = useAuth();
  const { handleLogout } = useMyPage();

  return (
    <Container>
      <TitleWrapper>マイページ</TitleWrapper>
      <ProfileInfoWrapper>
        <ProfileIcon src={userIcon}></ProfileIcon>
        <ProfileInfo>
          <ProfileName data-wovn-ignore>{loggedInUser?.name}</ProfileName>
          <ProfilePhoneNumber data-wovn-ignore>
            {loggedInUser?.phoneNumber}
          </ProfilePhoneNumber>
        </ProfileInfo>
      </ProfileInfoWrapper>

      <FavoriteStoreList />

      <Link
        href={PageRoutes.ORDER_HISTORY}
        color={BASIC_DARK_GRAY}
        fontWeight={600}
        text="利用履歴"
        size="md"
        labelBorderBottom
      />
      <Link
        href={PageRoutes.CUSTOMER_INFO_EDIT}
        color={BASIC_DARK_GRAY}
        fontWeight={600}
        text="会員情報変更"
        size="md"
        labelBorderBottom
      />
      <Link
        href={PageRoutes.EMAIL_EDIT}
        color={BASIC_DARK_GRAY}
        fontWeight={600}
        text="メールアドレスの変更"
        size="md"
        labelBorderBottom
      />

      <Link
        text="ログアウト"
        color={BASIC_DARK_GRAY}
        fontWeight={600}
        onClick={handleLogout}
        size="md"
        labelBorderBottom
      />

      <Link
        href={PageRoutes.DEACTIVATE}
        color={BASIC_DARK_GRAY}
        fontWeight={600}
        text="退会"
        size="md"
        labelBorderBottom
      />
      <ButtonWrapper>
        <BackToTopPageButton />
      </ButtonWrapper>
    </Container>
  );
};

const Container = styled.div`
  color: ${BASIC_DARK_GRAY};
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  text-align: left;
`;

const TitleWrapper = styled.p`
  font-size: 20px;
  font-weight: 600;
  padding: 36px 0 30px;
  line-height: 1;
  display: flex;
  justify-content: center;
`;

const ProfileIcon = styled.img`
  margin-right: 20px;
  width: 33px;
  height: 33px;
  background-size: cover;
`;

const ProfileInfoWrapper = styled.div`
  text-align: left;
  margin-bottom: 22px;
  padding: 0 0 22px 0;
  display: flex;
  border-bottom: 1px solid ${BASIC_LINE};
`;

const ProfileInfo = styled.div`
  text-align: left;
`;

const ProfileName = styled.p`
  padding: 0;
  margin: 0 0 3px 0;
  color: ${BASIC_DARK_GRAY};
  font-size: 16px;
  font-weight: 500;
`;

const ProfilePhoneNumber = styled.p`
  padding: 0;
  margin: 0;
  color: ${BASIC_DARK_GRAY};
  font-size: 14px;
  font-weight: 300;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 50px 0 45px;
  button {
    height: auto;
    line-height: 1;
    font-weight: 600;
    padding: 20px 0 18px;
  }
`;
